<script setup lang="ts">
import { ref } from 'vue'
import { apiAdmin, ExtendedRequestConfig } from '../../../api/ApiAdmin'
import MessageBox from '../../../services/MessageBox'

const endPoint = '/admin/upgrades/'

const items = [
  {id: 'admin_migrate', name: 'Admin Migrations', area: 'Admin', api: 'admin-migrate'},
  {id: 'admin_seed', name: 'Admin Seeders', area: 'Admin', api: 'admin-seed'}
]

const clientItems = [
  {id: 'client_migrate', name: 'Client Migrations', area: 'Client', api: 'client-migrate'},
  {id: 'client_seed', name: 'Client Seeders', area: 'Client', api: 'client-seed'}
]

const handleItemClick = async (item: any) => {
  const response = await apiAdmin.post(
      (endPoint.slice(-1) == "/"
        ? endPoint
        : endPoint + "/") + item.api,
      null
    );
    if (response.success == true) {
    }
}

interface Client {
  uid: string;
  company_name: string
}

const clients = ref<Client[]>([])
const progress = ref(0)
const isRunning = ref(false)

const handleClientItemClick = async (item: any) => {
  errors.value = []
  clients.value = []
  progress.value = 0
  isRunning.value = true;
  const response = await apiAdmin.post(
      (endPoint.slice(-1) == "/"
        ? endPoint
        : endPoint + "/") + 'clients',
      null
    );
    if (response.success == true) {
      clients.value = response.data;
      console.log('clients', clients.value);
      await runClientOps(item);
//      isRunning.value = false;
    } else {
      isRunning.value = false;
    }
  }

const runClientOps = async (item: any) => {
  progress.value = 0
  clients.value.forEach(async client => {
    const response = await apiAdmin.post(
      (endPoint.slice(-1) == "/"
        ? endPoint
        : endPoint + "/") + item.api,
      {
        uid: client.uid
      },
      {
      skipLoading: true
    } as ExtendedRequestConfig)
    if (response.success == true) {
      progress.value +=1 ;
      console.log('progress', progress.value);
      console.log('client', client.company_name);
    } else {
      progress.value +=1 ;
      handleError(client.company_name)
    }
    if (progress.value >= clients.value.length) {
        isRunning.value = false;
        if (errors.value.length > 0) {
          MessageBox.show("Some Databases could not be upgrader", 'error')
        } 
      }
  });  
  }

  const errors = ref<any[]>([])
  const handleError = (error: any) => {
    errors.value.push(error)
  }
</script>
<template>
  <div>

    <template v-if="errors.length > 0">
      <h1 class="text-red-500">Errors, The Following DBs could not be upgraded</h1>
      <div class="flex bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
        <div class="flex flex-col items-center">
          <div class="mb-1">
            <ol>
            <li v-for="error in errors" :key="error">{{ error }}</li>
            </ol>
          </div>
        </div>
        </div>
    </template>
    <template v-if="isRunning">
    <h1>Upgrades</h1>
    <div class="flex items-center justify-center h-screen">
      <div class="flex flex-col items-center">
        <div class="mb-1">
          <progress :value="progress > 0 && clients.length > 0 ? Math.ceil((progress/clients.length)*100) : 0" max="100" class="w-[300px]"></progress>          
        </div>
        <div class="mb-1">
          <label>{{ Math.ceil((progress/clients.length)*100) }}%</label>
        </div>
        <div class="mb-1">
          <label v-if="clients && clients.length > 0">Upgrading Client: {{ clients[progress].company_name }}</label>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <h3>Admin Ops</h3>
    <div class="grid grid-cols-4 gap-4">
      <div
        v-for="item in items"
        :key="item.id"
        class="rounded-lg border p-4 flex flex-col items-center justify-center"
      >
        <span>{{ item.name }}</span>
        <button
          class="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
          @click="handleItemClick(item)"
        >
          Start
        </button>
      </div>
    </div>

    <h3>Client Ops</h3>
    <div class="grid grid-cols-4 gap-4">
      <div
        v-for="item in clientItems"
        :key="item.id"
        class="rounded-lg border p-4 flex flex-col items-center justify-center"
      >
        <span>{{ item.name }}</span>
        <button
          class="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
          @click="handleClientItemClick(item)"
        >
          Start
        </button>
      </div>
    </div>
  </template>
  </div>
</template>